module.exports = __webpack_public_path__ + "static/media/cost-scale-icon.5aea62cb.svg";